import { useTranslation } from 'react-i18next';

import { Button } from '@treezor/design-system';

import { useAppDispatch, useAppSelector } from '@/hooks/redux-helpers';

import { openModal } from '@/store/actions/core.actions';

import { selectProfileByUserId } from '@/store/selectors';

import { useProfileContext } from '@/features/context/ProfileContext';

import { IForgotPasswordModalProps } from './ForgotPasswordModal';

export const SendForgotPassword = () => {
  const { t } = useTranslation();
  const { user } = useProfileContext();
  const dispatch = useAppDispatch();

  const isLoading = useAppSelector((state) => selectProfileByUserId(state, user.userId)?.isLoading);

  const toggleOpenModalPassword = () => {
    dispatch(openModal<IForgotPasswordModalProps>('passwordModal', { userId: user.userId, email: user.email }));
  };

  return (
    <Button id="send-forgot-password-btn" icon="vpn_key" onClick={toggleOpenModalPassword} disabled={isLoading}>
      {t('pages.currentProfiles.actionUser.forgotPassword')}
    </Button>
  );
};
